import styled, { css } from 'styled-components';

export const TopWrapper = styled.div`
  padding: 0;
  display: flex;
  margin: 10px;
  margin-right: 0;
  word-break: break-all;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

export const FilterContainer = styled.div`
  flex: 1 1 0%;
  overflow: hidden;
`;

export const SummaryDatePicker = styled.div`
  border-color: #dadada;
  border-radius: 6px;

  &.dod {
    border-radius: 0;
  }

  &.comparison-display {
    border-radius: 6px;
    background-color: #f5f5f5;
  }
`;

export const ComparisonDisplay = styled.div`
  border-radius: 6px;
  background-color: #f5f5f5;
  color: #666;
  font-size: 13px;
  min-width: 165px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ComparisonIntervals = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;
`;

export const ComparisonInterval = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ComparisonHour = styled.span`
  font-size: 10px;
  line-height: 1;
  color: #999;
`;

export const ComparisonDay = styled.span`
  font-size: 11px;
  line-height: 1;
  font-weight: 700;
  color: #777;
`;

export const ComparisonYear = styled.span`
  font-size: 10px;
  line-height: 1;
  color: #999;
  margin-left: 7px;
`;

export const ComparisonTo = styled.span`
  font-size: 11px;
  color: #999;
  margin: 0 4px;
`;

export const VsText = styled.div`
  display: flex;
  padding: 0 8px;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
`;

export const SummaryContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 20;
  margin: 0 5px;
  padding-right: 10px;
  background-color: #f5f5f5;
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-right: 0;
  align-self: flex-start;
  flex-wrap: nowrap;
  flex-grow: 0;
  margin-top: 3px;
  border-radius: 6px;
`;

export const DodToggleLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #555;
  cursor: pointer;
  white-space: nowrap;
  margin-right: 6px;
  user-select: none;

  input[type='checkbox'] {
    cursor: pointer;
    accent-color: #0f93f5;
    width: 13px;
    height: 13px;
  }
`;

export const DatePickers = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #dadada;
  border-radius: 6px;
  padding: 1px;
`;

export const Vs = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  border: 1px solid #dadada;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  line-height: 20px;
  vertical-align: middle;
  text-align: center;
  background-color: white;
  z-index: 80;
`;

export const Separator = styled.div<{ selected?: boolean }>`
  border-left: 1px solid #dadada;
  position: relative;
  ${(props) =>
    props.selected &&
    css`
      border-left-color: #1890ff;
    `}
`;

export const Options = styled.div`
  margin-right: -16px;
  margin-left: 5px;

  .ant-btn-circle.ant-btn-lg {
    height: 32px;
    width: 32px;
  }

  .ant-btn {
    border: 0;
    box-shadow: none;
  }
`;

export const Unavailable = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 8px;
  border: 1px solid #dadada;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: #f6f6f6;
  color: #9b9b9b;
  font-size: 12px;
`;
